import { Flex } from '@radix-ui/themes'
import { styles } from './styles.css'
import checkedImage from './checked.svg'
import uncheckedImage from './unchecked.svg'

type Props = {
  checked: boolean
  children: React.ReactNode
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const Checkbox: React.FC<Props> = ({ checked, children, onChange }) => {
  const image = checked ? checkedImage : uncheckedImage

  return (
    <label className={styles.label}>
      <Flex direction="row" align="center" justify="start" gap="2" width="100%">
        <div>
          <img src={image} className={styles.checkmark} />
          <input type="checkbox" className={styles.checkbox} defaultChecked={checked} onChange={onChange} />
        </div>
        <span className={styles.labelText}>{children}</span>
      </Flex>
    </label>
  )
}
